import React from "react";
import { withNamespaces } from "react-i18next";
import { Button } from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { pagination } from "~/components/pagination/currentSizePerPage/5";

const IntegracaoTable = ({ currentList, columns, handleCall, t }) => {
  const { SearchBar } = Search;

  return (
    <div className="custom-table withoutOverflow">
      <ToolkitProvider
        keyField="id"
        data={currentList}
        columns={columns}
        search={{ searchFormatted: true }}
      >
        {(props) => (
          <div>
            <div
              style={{
                marginBottom: "0.5rem",
                marginLeft: "10px",
                display: "flex",
                paddingTop: "25px",
                paddingLeft: "5px",
                justifyContent: "space-between", // Adicionado para alinhar os itens
                alignItems: "center", // Adicionado para centralizar verticalmente
              }}
            >
              <SearchBar
                {...props.searchProps}
                placeholder={t("general.search")}
              />
            </div>
            <BootstrapTable
              {...props.baseProps}
              id="document-table"
              responsive
              bootstrap4
              pagination={paginationFactory(pagination)}
              noDataIndication={t("datacapture.general.dataNotFound")}
              pageSize={5}
              hover
              striped
            />
            <div style={{display: "flex", gap: "1rem", marginTop: "1rem", justifySelf: "flex-end"}}>
              <Button
                id="button_rhadmin_integration_table_integrate"
                className="card-button"
                onClick={() => handleCall("2")}
                style={{ marginLeft: "15px" }}
              >
                {t("portalrh.rhadmin.integracao.export")}
              </Button>
              <Button
                id="button_rhadmin_integration_table_integrate"
                className="card-button"
                onClick={() => handleCall("3")}
                style={{ marginLeft: "15px" }}
              >
                {t("portalrh.rhadmin.integracao.integrate")}
              </Button>
            </div>
            <BootstrapTable
              {...props.baseProps}
              id="document-table-exportabsence"
              responsive
              bootstrap4
              noDataIndication={t("datacapture.general.dataNotFound")}
              hover
              striped
            />
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default withNamespaces()(IntegracaoTable);
